import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Line } from 'react-chartjs-2';

function GraficaAmperajePorMaquina({ fechaInicio, fechaFin, maquina }) {
  const [dataApi, setDataApi] = useState([]);
  const [, setLoading] = useState(false);

  useEffect(() => {
    if (fechaInicio && fechaFin) {
      setLoading(true);
      let url = `/api/promedio-amperaje-dia?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
      if (maquina) url += `&maquinaId=${maquina}`;
      fetch(url)
        .then(res => {
          if (!res.ok) throw new Error('Error en la API');
          return res.json();
        })
        .then(data => {
          setDataApi(Array.isArray(data) ? data : []);
        })
        .catch(err => {
          setDataApi([]);
          console.error('Error al obtener datos de amperaje:', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [fechaInicio, fechaFin, maquina]);

  // Solo mostrar máquinas realmente presentes en los datos
  const datosFiltrados = dataApi.filter(d => !maquina || d.maquinaId === maquina);
  const amperajePorDia = {};
  datosFiltrados.forEach(d => {
    if (!amperajePorDia[d.fecha]) amperajePorDia[d.fecha] = [];
  amperajePorDia[d.fecha].push(Number(d.promedioAmperaje));
  });
  const labels = Object.keys(amperajePorDia).sort();
  const promedios = labels.map(f => {
    const arr = amperajePorDia[f];
    if (arr.length === 0) return 0;
    return arr.reduce((a, b) => a + b, 0) / arr.length;
  });
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Amperaje promedio',
        data: promedios,
        borderColor: 'rgba(249,55,167,1)',
        backgroundColor: 'rgba(249,55,167,0.2)',
        borderWidth: 1, // línea más delgada
        tension: 0.7, // curva más acentuada
        pointRadius: 3,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Amperaje por día (${maquina || 'Todas'})` },
    },
    scales: {
      x: {
        title: { display: true, text: 'Día' },
        ticks: {
          font: { size: 10 },
          maxTicksLimit: 28,
          autoSkip: true,
          stepSize: 1,
        },
        grid: {
          lineWidth: 0.5,
          drawTicks: true,
        },
        offset: false,
      },
      y: { title: { display: true, text: 'Amperaje (A)' } },
    },
  };
  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Gráfica de amperaje por máquina
      </Typography>
      <Box sx={{ height: 350, overflowX: 'auto', width: '100%' }}>
        {labels.length === 0 ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            No hay datos para el rango seleccionado
          </Typography>
        ) : (
          <Box sx={{ minWidth: 600, maxWidth: '100%' }}>
            <Line data={chartData} options={options} />
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default GraficaAmperajePorMaquina;
